import axios from "axios";
import { errorHandler } from "@/Services/errorHandler";
import queryStringify from "qs-stringify";

export default {
  state: {
    paymentMethods: [],
  },
  getters: {
    getPaymentMethods: (state) => state.paymentMethods,
  },
  mutations: {
    setPaymentMethods(state, payload) {
      state.paymentMethods = payload;
      localStorage.setItem("paymentMethods", JSON.stringify(payload));
    },
  },
  actions: {
    getSalesData: async (context, data) => {
      let route = data.route;
      let query = data.query;
      let payload = {
        ...query,
        ...context.getters.getTimeFrame,
      };
      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null ? window.btoa(storeDB) : null,
      };

      const queryString = `?` + queryStringify(payload);
      return axios
        .get(reportsApi + `${route}` + queryString, {
          headers,
        })
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },

    async getDepartments() {
      let stores = JSON.parse(localStorage.getItem(`stores`));
      let store = JSON.parse(localStorage.getItem(`selected_store`));

      if (stores.length === 0) return;

      let storeDB = store.StoreDB;

      return axios
        .get(serverApi + `category/${storeDB}/getAsTree`)
        .then(({ data }) => data)
        .catch((err) => errorHandler.tomcatError(err));
    },
    async getPaymentMethod(context) {
      let store = JSON.parse(localStorage.getItem("selected_store"));
      let stores = JSON.parse(localStorage.getItem("stores"));

      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB ? window.btoa(storeDB) : null,
      };

      const queryString = `?` + queryStringify(payload);
      try {
        const { data } = await axios.get(
          reportsApi + `sales/store-sales-by-department` + queryString,
          { headers }
        );
        return data;
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },

    // Printing functions

    async printSalesPDF(context, fileData) {
        console.log({fileData})
      // If a docs route is provided, use the existing blob download flow
      const route = fileData.route;
      const fileName = fileData.fileName;

      // Get selected store and timeframe the same way the page does
      const selected = context.rootGetters && context.rootGetters.getStore;
      const storeDB = selected && selected.StoreDB;
      const timeFrame = context.getters.getTimeFrame || {};
      const printTimeFrame = context.rootGetters.getPrintTimeFrame || {};
      const toDateOnly = (s) => (typeof s === 'string' ? s.substring(0, 10) : s);

      // Format datetime-local value (YYYY-MM-DDTHH:mm) to Y-m-d H:i:s for backend
      const formatForBackend = (dt) => {
        if (!dt) return null;
        const d = new Date(dt);
        const pad = (n) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      };

      // Use datetime inputs if set, otherwise fall back to date-only from Timeline
      const finalFrom = formatForBackend(printTimeFrame.printFromDatetime) || toDateOnly(timeFrame.from);
      const finalTo = formatForBackend(printTimeFrame.printToDatetime) || toDateOnly(timeFrame.to);

      // Map quick printable keys to URL builders (no hardcoded full URLs in components)
      const builders = {
        salesPerCashier: ({ from, to, storeDB }) => `${window.pdfReportApi}CashierSales/${storeDB}?from=${from}&to=${to}`,
        salesPerWaiter: ({ from, to, storeDB, limit = 750 }) => `${window.salesReportsPrintApi}${storeDB}/getWaiterSales?from=${from}&to=${to}&limit=${limit}`,
        cashierDepartmentSales: ({ from, to, storeDB }) => `${window.pdfReportApi}CashierDepartmentSales/${storeDB}?from=${from}&to=${to}`,
        bestSellers: ({ from, to, storeDB, limit = 750 }) => `${window.pdfReportApi}TopSellers/${storeDB}?from=${from}&to=${to}&limit=${limit}`,
        turnoverReport: ({ from, to, storeDB }) => `${window.pdfReportApi}MonthlyTurnover/${storeDB}?from=${from}&to=${to}`,
        worstSellers: ({ from, to, storeDB }) => `${window.pdfReportApi}WorstSellers/${storeDB}?from=${from}&to=${to}`,
        departmentPerformance: ({ from, to, storeDB, limit = 750 }) => `${window.pdfReportApi}DepartmentSales/${storeDB}?from=${from}&to=${to}&limit=${limit}`,
        salesPerComputer: ({ from, to, storeDB }) => `${window.pdfReportApi}PCSales/${storeDB}?from=${from}&to=${to}`,
        pcDepartmentSales: ({ from, to, storeDB }) => `${window.pdfReportApi}PCDepartmentSales/${storeDB}?from=${from}&to=${to}`,
        inactivePerformance: ({ from, to, storeDB }) => `${window.pdfReportApi}InactiveStock/${storeDB}?from=${from}&to=${to}`,
        salesSummary: ({ from, to, storeDB }) => `${window.pdfReportApi}SalesSummary/${storeDB}?from=${from}&to=${to}`,
        hourlySalesReport: ({ from, to, storeDB }) => `${window.pdfReportApi}HourlySales/${storeDB}?from=${from}&to=${to}`,
        dailyOverviewReport: ({ from, to, storeDB, limit = 750 }) => `${window.pdfReportApi}Daily/${storeDB}?from=${from}&to=${to}&limit=${limit}`,
        averageHourlySales: ({ from, to, storeDB }) => `${window.pdfReportApi}AvgHourlySales/${storeDB}?from=${from}&to=${to}`,
        businessOverview: ({ from, to, storeDB }) => `${window.pdfReportApi}StoreOverview/${storeDB}?from=${from}&to=${to}`,
      };

      // If no route is provided but value matches a quick printable
      if ((!route || route === '') && fileData && fileData.value && builders[fileData.value]) {
        if (!storeDB) {
          // Same UX pattern as page: require a store selection
          Toast && Toast.fire && Toast.fire({
            icon: 'error',
            title: 'Store Selection Required',
            text: 'Please select a store to continue.',
            timer: 3000,
          });
          return;
        }
        if (!finalFrom || !finalTo) {
          console.error('Missing date range.');
          return;
        }
        const url = builders[fileData.value]({ from: finalFrom, to: finalTo, storeDB });
        // Android: fetch bytes and open natively (avoid blank WebView tab)
       /* const isAndroid = (window.Capacitor && window.Capacitor.getPlatform && window.Capacitor.getPlatform() === 'android');
        if (isAndroid) {
          try {
            const res = await axios.get(url, { responseType: 'arraybuffer' });
            const fakeResponse = { data: res.data, headers: { 'content-type': 'application/pdf' } };
            window.openFile(fakeResponse, fileName || 'report');
          } catch (err) {
            errorHandler.tomcatError(err);
          }
          return;
        }*/

        // Non-Android (web/electron): open in a new tab as before
        window.open(url, '_blank');
        return; // Done
      }
    },

    async printStockCSV(context, fileData) {
      let route = fileData.route;
      let fileName = fileData.fileName;
      let payload = {
        ...context.getters.getTimeFrame,
      };

      let stores = JSON.parse(localStorage.getItem("stores"));
      if (!stores || stores.length === 0) return;
      let group = stores[0].Group;
      let store = JSON.parse(localStorage.getItem("selected_store"));
      let storeDB = store && store.StoreDB;
      if (!storeDB) {
        Toast && Toast.fire && Toast.fire({
          icon: "error",
          title: "Store Selection Required",
          text: "Please select a store to continue.",
          timer: 3000,
        });
        return;
      }

      const queryString = `?` + queryStringify(payload);
      let headers = {
        group: window.btoa(group),
        DB: window.btoa(storeDB),
      };

      try {
        const response = await axios.get(docsApi + `${route}` + queryString, {
          headers,
          responseType: `blob`,
        });
        openFile(response, fileName);
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },

    // Get detailed department sales data for Excel export
    async getDepartmentSalesDetails(context, payload = {}) {
      let stores = JSON.parse(localStorage.getItem("stores"));
      let store = JSON.parse(localStorage.getItem("selected_store"));

      if (stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null ? window.btoa(storeDB) : null,
      };

      const timeFrame = context.getters.getTimeFrame || {};
      const queryParams = {
        from: payload.from || timeFrame.from || timeFrame.startTime,
        to: payload.to || timeFrame.to || timeFrame.endTime,
      };

      // Add department filter if provided and not "All"
      if (payload.department && payload.department !== "All") {
        queryParams.department = payload.department;
      }

      const queryString = `?` + queryStringify(queryParams);
      try {
        const { data } = await axios.get(
          reportsApi + `sales/store-sales-by-department-details` + queryString,
          { headers }
        );
        return data;
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },

    // Get list of departments from stock table for filtering
    async getStoreDepartments(context) {
      let stores = JSON.parse(localStorage.getItem("stores"));
      let store = JSON.parse(localStorage.getItem("selected_store"));

      if (stores.length === 0) return;
      let group = stores[0].Group;
      let storeDB = store.StoreDB;

      let headers = {
        group: window.btoa(group),
        DB: storeDB !== null ? window.btoa(storeDB) : null,
      };

      try {
        const { data } = await axios.get(
          reportsApi + `sales/store-departments`,
          { headers }
        );
        return data;
      } catch (err) {
        errorHandler.tomcatError(err);
      }
    },

    /**
     * Fetch aggregated department performance across every store in the
     * authenticated user's franchise group.
     *
     * NOTE: This action differs from the per-store actions in this module.
     * Per-store endpoints (`getStoreDepartments`, etc.) are scoped to one
     * store and legitimately short-circuit when no store is selected. The
     * multi-store aggregation endpoint, by contrast, should always be called
     * so the backend can derive the user's group from auth context if needed.
     * We therefore:
     *   - Parse `localStorage["stores"]` defensively (null/parse errors ->
     *     empty array instead of throwing).
     *   - Never return early on missing stores; we log a warning and proceed
     *     so the API can still answer (the backend groups by franchise).
     *   - Only attach the `group` header when we actually have a store to
     *     pull a group from; an empty headers object is acceptable.
     *   - Re-throw the axios error so the calling component's catch block
     *     can surface a user-visible message instead of a silent failure.
     *
     * @param {Object} context   Vuex action context
     * @param {Object} [payload] Optional `{ from, to }` ISO date overrides
     * @returns {Promise<Object>} Report payload `{ summary, departments }`
     */
    async getMultiStoreDepartmentPerformance(context, payload = {}) {
      let stores;
      try {
        stores = JSON.parse(localStorage.getItem("stores") || "[]");
      } catch (e) {
        stores = [];
      }

      if (!Array.isArray(stores) || stores.length === 0) {
        console.warn(
          "[MultiStoreDepartmentPerformance] No stores in localStorage — proceeding without `group` header; backend will derive group from auth context."
        );
      }

      const group = Array.isArray(stores) && stores.length > 0 ? stores[0].Group : null;
      const headers = group ? { group: window.btoa(group) } : {};

      const timeFrame = context.getters.getTimeFrame || {};
      const queryParams = {
        from: payload.from || timeFrame.from || timeFrame.startTime,
        to: payload.to || timeFrame.to || timeFrame.endTime,
      };

      const queryString = `?` + queryStringify(queryParams);
      try {
        const { data } = await axios.get(
          reportsApi + `sales/multi-store-department-performance` + queryString,
          { headers }
        );
        return data;
      } catch (err) {
        errorHandler.tomcatError(err);
        // Re-throw so the component's catch block can show a user-visible error.
        throw err;
      }
    },
  },
};
